import React, { useLayoutEffect } from "react";
import { ReactComponent as CloseIcon } from "common/assets/icons/x.svg";
import { Htag } from "common/Htag/Htag";
import { Button } from "common/Button/Button";
import { motion } from "framer-motion";
import { ManagePanelProps } from "./ManagePanel.props";
import { P } from "common/P/P";

const ManagePanel: React.FC<ManagePanelProps> = ({
	isOpen,
	onClose,
	label,
	onSubmit,
	onCancel,
	children,
	width,
}) => {
	useLayoutEffect(() => {
		if (isOpen) {
			document.body.style.overflow = "hidden";
		}
		return () => {
			document.body.style.removeProperty("overflow");
		};
	}, [isOpen]);

	const panelVariants = {
		open: { x: 0, transition: { duration: 0.3 } },
		closed: { x: "100%", transition: { duration: 0.3 } },
		exit: { x: "100%", transition: { duration: 0.3 } },
	};

	return (
		<>
			<div
				className={`${
					isOpen ? "fixed inset-0 z-40" : "hidden"
				} backdrop-blur-sm bg-[rgba(47,47,47,0.65)]`}
				onClick={onClose}
			></div>
			{isOpen && (
				<motion.div
					key="managePanel"
					initial="closed"
					animate="open"
					exit="exit"
					variants={panelVariants}
					className={`fixed top-0 bottom-0 right-0 ${
						width ? width : "minPhone:w-full xl:w-[475px]"
					} bg-whiteColor flex flex-col z-50`}
				>
					<div className="z-10 flex gap-6 py-6 bg-white border-b minPhone:px-4 xl:px-8 border-strokeColor place-items-center place-content-between">
						<P
							size="p1"
							type="regular"
							className="text-[#4B465C] cursor-default"
						>
							{label}
						</P>
						<CloseIcon
							onClick={onClose}
							className="cursor-pointer stroke-[#4B465C]"
						/>
					</div>
					<div className="flex-grow py-6 overflow-y-auto bg-white minPhone:px-4 xl:px-6">
						{children}
					</div>
					<div className="grid w-full grid-cols-2 gap-4 px-8 py-6 bg-white border-t border-strokeColor">
						<Button appearance="ghost" onClick={onSubmit} width="w-full">
							<P size="p2" type="regular" className="cursor-pointer">
								Arassala
							</P>
						</Button>
						<Button appearance="main" onClick={onSubmit} width="w-full">
							<P size="p2" type="regular" className="cursor-pointer">
								Gözle
							</P>
						</Button>
					</div>
				</motion.div>
			)}
		</>
	);
};

export default ManagePanel;
